"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.USER_AGENT_HEADER_KEY = void 0;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
var environment_1 = require("../environment");
var VERSION_PATTERN = /^(?:\d+\.)?(?:\d+\.)?(?:\d+\.)?(?:\d+)$/;
exports.USER_AGENT_HEADER_KEY = "x-snap-client-user-agent";
var SPECIAL_CASTS = {
    chromiumos: "chromeos"
};
function getUserAgent(_a) {
    var _b = _a === void 0 ? {} : _a, userAgent = _b.userAgent, _c = _b.appName, appName = _c === void 0 ? "SnapchatWeb" : _c, _d = _b.appVersion, appVersion = _d === void 0 ? (0, environment_1.getAppEnvironment)().appVersion : _d, _e = _b.appFlavor, appFlavor = _e === void 0 ? (0, environment_1.getAppEnvironment)().appBuild.toUpperCase() : _e;
    userAgent = userAgent !== null && userAgent !== void 0 ? userAgent : navigator.userAgent;
    var _f = (0, ua_parser_js_1["default"])(userAgent), os = _f.os, browser = _f.browser;
    return "".concat(appName, "/").concat(getSemVer(appVersion === null || appVersion === void 0 ? void 0 : appVersion.split("-")[0]), " ").concat(appFlavor, " (").concat(getFormattedNameAndVersionForOsOrBrowser(os), "; ").concat(getFormattedNameAndVersionForOsOrBrowser(browser), ")");
}
exports["default"] = getUserAgent;
function getFormattedNameAndVersionForOsOrBrowser(_a) {
    var name = _a.name, version = _a.version;
    name = toLowerAndTrim(name);
    version = getSemVer(version);
    if (name in SPECIAL_CASTS) {
        name = SPECIAL_CASTS[name];
    }
    return "".concat(name, " ").concat(version);
}
function toLowerAndTrim(name) {
    return (name || "").replace(/\s/g, "").toLowerCase();
}
function getSemVer(version) {
    version = version || "";
    if (!VERSION_PATTERN.test(version)) {
        version = "0.0.0";
    }
    return version;
}
//# sourceMappingURL=userAgent.js.map